import type { Locale } from "./homepage-seo.ts";
import { formatLocalizedNumber } from "./locale-format.ts";
import {
  strategyBuilderIndicatorLabel,
  strategyBuilderOperatorLabel,
  strategyBuilderParameterLabel,
} from "./strategy-builder-i18n.ts";
import type { StrategyRuleCondition, StrategyRuleOperand } from "./strategy-builder.ts";

export function strategyConditionSummary(
  locale: Locale,
  condition: StrategyRuleCondition,
): string {
  const parts = [
    strategyOperandSummary(locale, condition.left),
    strategyBuilderOperatorLabel(locale, condition.operator),
  ];
  if (condition.right) parts.push(strategyOperandSummary(locale, condition.right));
  return parts.join(" ");
}

function strategyOperandSummary(locale: Locale, operand: StrategyRuleOperand): string {
  if (operand.kind === "number") {
    return formatLocalizedNumber(operand.value, locale, { maximumFractionDigits: 4 });
  }
  const label = strategyBuilderIndicatorLabel(locale, operand.id);
  const parameters = Object.entries(operand.parameters)
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([key, value]) =>
      `${strategyBuilderParameterLabel(locale, key)} ${formatLocalizedNumber(value, locale, { maximumFractionDigits: 4 })}`);
  return parameters.length ? `${label} (${parameters.join(" · ")})` : label;
}
